<vw-header-padding-safe-area></vw-header-padding-safe-area>
<div class="px-4">
  <!-- Page title -->
  <div class="pb-3">
    <h2 class="font-display text-display text-vw-ink">{{ 'agenda.title' | translate }}</h2>
    <!-- « n choses à faire », sur les deux onglets ; rien à zéro, l'état vide le dit. -->
    @if (todoCount) {
    <p data-test="agenda-subtitle" class="pt-0.5 text-body-s text-vw-muted">
      {{ (todoCount === 1 ? 'agenda.subtitle.one' : 'agenda.subtitle.many') | translate: { n: todoCount } }}
    </p>
    }
  </div>

  <!-- Tab component that displays different content based on selected tab -->
  <vw-tab [tabs]="tabData" (tabSelected)="onTabSelected($event)" [activeTab]="activeTab">
    <div class="tab-content">
      <!-- Active tab content will be loaded here -->
      <router-outlet (activate)="onActivate($event)" (deactivate)="onDeactivate()"></router-outlet>
    </div>
  </vw-tab>
</div>
